import type { ModalEntries } from '@vnetwork/datacentral-shell/host'

// The module's modals, registered with the host by createDriveModule (#216).
// require.context cannot see packages/, so they are declared here, one entry
// per modal, under the keys setModal('<Group>/<Modal>/index') has always used.
// check:modal-keys reads this file: keep every entry as
// '<key>': () => import('<relative path>').
export const driveModals = {
    'DriveModals/ModifyObjectModal/index': () =>
        import('./modals/DriveModals/ModifyObjectModal'),
    'DriveModals/MoveObjectModal/index': () =>
        import('./modals/DriveModals/MoveObjectModal'),
    'DriveModals/ObjectInfoModal/index': () =>
        import('./modals/DriveModals/ObjectInfoModal'),
    'DriveModals/ShareObjectModal/index': () =>
        import('./modals/DriveModals/ShareObjectModal'),
    'DriveModals/UploadConflictModal/index': () =>
        import('./modals/DriveModals/UploadConflictModal'),
} satisfies ModalEntries
